'use strict';

require('./bootstrap');
require('./map');
import bsCustomFileInput from 'bs-custom-file-input';

(function () {
    // Dropzone.autoDiscover = false;

    $.fn.focusToEnd = function () {
        return this.each(function () {
            var v = $(this).val();
            $(this).focus().val('').val(v);
        });
    };

    $(function () {
        bsCustomFileInput.init();

        $('[data-toggle=geolocation]').each(function() {
            if ( navigator.geolocation ) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        $('[data-submit]').on('click', function (e) {
            var button = $(this);
            var form = button.closest('form');

            var label = button.data('submit') || '';

            if (label == '') {
                button.css({ width: button.outerWidth() });
            }

            button
                .data('text', button.html())
                .addClass('disabled')
                .prop('disabled', true)
                .html(
                    '<span class="spinner-border spinner-border-sm mr-1" role="status"></span>' +
                        label
                );

            if (
                typeof form[0].checkValidity == 'function' &&
                !form[0].checkValidity()
            ) {
                button
                    .html(button.data('text'))
                    .removeClass('disabled')
                    .prop('disabled', false);
                var submit = $('<input type="submit">');
                submit.hide().appendTo(form).click();
                submit.remove();
                return;
            }

            if (button.prop('name') && button.prop('value')) {
                form.append(
                    $('<input>', {
                        name: button.prop('name'),
                        value: button.prop('value'),
                        type: 'hidden',
                    })
                );
            }

            form[0].submit();
        });

        var holidayTermsCheckbox = $('#holiday-terms-checkbox');

        if (holidayTermsCheckbox.length > 0) {
            holidayTermsCheckbox
                .on('change', function () {
                    if (holidayTermsCheckbox.is(':checked')) {
                        $('#holiday-book-spaces').show();
                    } else {
                        $('#holiday-book-spaces').hide();
                    }
                })
                .trigger('change');
        }

        var avatarCrop = $('#avatar-crop');

        if (avatarCrop.length > 0) {
            var avatarCropImg = $('img', avatarCrop).cropper({
                autoCropArea: 1,
                rotatable: true,
            });
            $('[data-method]', avatarCrop).on('click', function () {
                var button = $(this);
                avatarCropImg.cropper(
                    button.data('method'),
                    button.data('option')
                );
            });
            avatarCrop.on('submit', function (e) {
                e.preventDefault();
                var button = $('button[type=submit]', avatarCrop);
                button.prop('disabled', true).text('Saving...');
                var data = avatarCropImg.cropper('getData');
                $.each(data, function (key, value) {
                    if (key == 'rotate' && value < 0) {
                        value = value + 360;
                    }
                    avatarCrop.append(
                        $('<input>', {
                            name: key,
                            value: value,
                            type: 'hidden',
                        })
                    );
                });
                avatarCrop[0].submit();
            });
        }

        $('.booking-countdown').each(function () {
            var element = $(this);
            var expires = moment(element.data('expires'));

            $(element).countdown(expires.toDate(), function (e) {
                if (e.type == 'finish') {
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    element.html(
                        e.strftime(
                            '' +
                                '<span>%M</span> Minutes ' +
                                '<span>%S</span> Seconds'
                        )
                    );
                }
            });
        });

        $('body').on('click', '.messages li[data-href]', function (e) {
            var target = $(e.target);
            if (
                !target.is('a') &&
                !target.is('input') &&
                !target.is('.dropdown') &&
                target.closest('.dropdown').length == 0
            ) {
                window.location.href = $(this).data('href');
            }
        });

        $('[data-toggle="tooltip"]').tooltip({
            placement: 'bottom',
        });

        $('a[data-method]').on('click', function (e) {
            e.preventDefault();
            var link = $(this);
            var method = link.data('method');
            var csrf = $('<input>', {
                name: '_token',
                value: window.csrfToken,
                type: 'hidden',
            });
            var form = $('<form>', {
                action: link.attr('href'),
                method: method == 'DELETE' ? 'POST' : method,
                target: '_top',
            }).append(csrf);
            if (method == 'DELETE') {
                form.append(
                    $('<input>', {
                        name: '_method',
                        value: 'DELETE',
                        type: 'hidden',
                    })
                );
            }
            if (link.data('confirm')) {
                if (
                    confirm(
                        'Are you sure you want to ' + link.data('confirm') + '?'
                    )
                ) {
                    form.appendTo(document.body).submit();
                }
            } else {
                form.appendTo(document.body).submit();
            }
        });

        $('input[data-confirm], button[data-confirm]').on(
            'click',
            function (e) {
                var button = $(this);
                var form = button.closest('form');

                var title = button.data('confirm') ?? 'perform that action';

                e.preventDefault();

                if (confirm('Are you sure you want to ' + title + '?')) {
                    if (button.attr('name')) {
                        form.append(
                            $('<input>', {
                                name: button.attr('name'),
                                value: button.val(),
                                type: 'hidden',
                            })
                        );
                    }
                    form[0].submit();
                }

                return false;
            }
        );

        $('input[data-confirm-delete], button[data-confirm-delete]').on(
            'click',
            function (e) {
                var button = $(this);
                var form = button.closest('form');

                var title = button.data('confirmDelete');

                e.preventDefault();
                if (confirm('Are you sure you want to delete ' + title + '?')) {
                    form[0].submit();
                }

                return false;
            }
        );

        $('.modal[data-show]').each(function () {
            $(this).modal({
                show: true,
            });
        });

        $('.carousel-friends').each(function () {
            var carousel = $(this);
            carousel.carousel({
                interval: false,
                keyboard: false,
                pause: false,
            });
            $('.carousel-indicators [data-slide-to]')
                .first()
                .addClass('active');
            carousel.on('click', '[data-slide-to]', function (e) {
                var link = $(this);
                var index = link.data('slideTo');
                carousel.carousel(index);
                $('.carousel-indicators li', carousel).removeClass('active');
            });
            carousel.on('click', '[data-slide="prev"]', function (e) {
                carousel.carousel('prev');
                $('.carousel-indicators li', carousel).removeClass('active');
            });
            carousel.on('click', '[data-slide="next"]', function (e) {
                carousel.carousel('next');
                $('.carousel-indicators li', carousel).removeClass('active');
            });
            carousel.on('slid.bs.carousel', function (e) {
                $('.carousel-indicators li', carousel).removeClass('active');
                $(
                    '.carousel-indicators [data-slide-to="' + e.to + '"]'
                ).addClass('active');
            });
        });

        $('#event-target-all')
            .on('change', function () {
                var all = $(this);
                var checkboxes = $(
                    'input[name="targets[]"]',
                    all.closest('form')
                );
                if (all.is(':checked')) {
                    checkboxes.each(function () {
                        var checkbox = $(this);
                        checkbox.prop('disabled', true);
                        checkbox.data('wasChecked', checkbox.is(':checked'));
                        checkbox.prop('checked', false);
                    });
                } else {
                    checkboxes.each(function () {
                        var checkbox = $(this);
                        checkbox.prop('disabled', false);
                        if (checkbox.data('wasChecked')) {
                            checkbox.prop('checked', true);
                        }
                    });
                }
            })
            .trigger('change');

        $('#user-map').each(function () {
            var element = $(this);
            var map = new google.maps.Map(element.get(0), {
                zoom: 12,
                center: new google.maps.LatLng(
                    element.data('lat'),
                    element.data('lng')
                ),
                panControl: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false,
            });
            var marker = new google.maps.Marker({
                position: {
                    lat: element.data('lat'),
                    lng: element.data('lng'),
                },
                map: map,
            });
        });

        $('#user-map-modal').on('show.bs.modal', function (event) {
            var element = $('#user-map');
            var map = new google.maps.Map(element.get(0), {
                zoom: 12,
                center: new google.maps.LatLng(
                    element.data('lat'),
                    element.data('lng')
                ),
                panControl: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false,
            });
            var marker = new google.maps.Marker({
                position: {
                    lat: element.data('lat'),
                    lng: element.data('lng'),
                },
                map: map,
            });
        });

        $('[data-maxlength-counter]').each(function () {
            var input = $(this);
            var target = $(input.data('maxlength-counter'));
            if (target.length > 0 && input.prop('maxlength')) {
                input
                    .on(
                        'keyup',
                        _.debounce(function (e) {
                            var remaining =
                                input.prop('maxlength') -
                                input.val().trim().length;
                            target.text(remaining + ' Characters Left');
                        }, 100)
                    )
                    .trigger('keyup');
            }
        });

        $.fn.select2.defaults.set('theme', 'bootstrap4');

        $('.profiles-collection').each(function () {
            var collection = $(this);
            var checkboxes = $('input[type=checkbox]', collection);
            $('[data-toggle="select-all"]', collection).on(
                'click',
                function (e) {
                    e.preventDefault();
                    $(checkboxes).prop('checked', true).first().change();
                }
            );
            $('[data-toggle="select-none"]', collection).on(
                'click',
                function (e) {
                    e.preventDefault();
                    $(checkboxes).prop('checked', false).first().change();
                }
            );
        });

        $('[data-toggle="copy-clipboard"]').on('click', function () {
            var target = $($(this).data('target'));
            if (target.length == 1) {
                target.get(0).select();
                target.get(0).setSelectionRange(0, 99999);
                navigator.clipboard.writeText(target.val());
            }
        });

        $('form[data-toggle="actions"]').each(function () {
            var form = $(this);
            var selectedInput = $('input[name=selected]', form);
            var checkboxesSelector =
                'input[data-toggle=actions][data-parent="#' +
                form.attr('id') +
                '"]';
            $('[data-toggle="select-all"]', form).on('click', function () {
                $(checkboxesSelector).prop('checked', true).first().change();
            });
            selectedInput
                .on('change', function () {
                    if (selectedInput.val() == '') {
                        $('button[type=submit]', form).prop('disabled', true);
                    } else {
                        $('button[type=submit]', form).prop('disabled', false);
                    }
                })
                .change();
            $(checkboxesSelector).on('change', function () {
                selectedInput
                    .val(
                        $(checkboxesSelector)
                            .filter(':checked')
                            .map(function () {
                                return this.value;
                            })
                            .get()
                            .join(',')
                    )
                    .trigger('change');
            });
        });

        $('[data-select-tags]').each(function () {
            var input = $(this);
            input.select2({
                minimumInputLength: 2,
                tags: true,
                ajax: {
                    url: window.App.base_url + '/api/tags',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true,
                    },
                    data: function (params) {
                        var query = {
                            query: params.term,
                            page: params.page || 1,
                        };
                        return query;
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data.data, function (tag) {
                                return {
                                    id: tag.name,
                                    text: tag.name,
                                    slug: tag.slug,
                                };
                            }),
                            pagination: {
                                more:
                                    data.meta.pagination.current_page <
                                    data.meta.pagination.total_pages,
                            },
                        };
                    },
                },
            });
        });

        $('[data-select]').each(function () {
            $(this).select2();
        });

        $('[data-select-username]').each(function () {
            var input = $(this);
            var select = input;
            var selectedUsername = select.val();
            var friends_only = !!select.data('friends-only');
            var ajax_url = window.App.base_url + '/api/users';

            if (friends_only) {
                ajax_url += '?friends_only=1';
            }

            if (!input.is('select')) {
                select = $('<select></select>');
                $.each(this.attributes, function () {
                    if (this.name != 'type') {
                        select.attr(this.name, this.value);
                    }
                });
                if (selectedUsername) {
                    select
                        .append(
                            $(
                                '<option value="' +
                                    selectedUsername +
                                    '" selected>' +
                                    selectedUsername +
                                    '</option>'
                            )
                        )
                        .change();
                }
                select.insertAfter(input);
                input.hide().remove();
            }
            select.select2({
                minimumInputLength: 2,
                templateResult: function (user) {
                    if (user.loading) {
                        return user.text;
                    }
                    return $(
                        "<div class='select2-result-user d-flex'>" +
                            "<div class='select2-result-user__avatar'><img src='" +
                            user.avatar.thumb +
                            "' style='width: 20px; margin-right: 1rem;' /></div>" +
                            "<div class='select2-result-user__username'>" +
                            user.username +
                            '</div>' +
                            '</div>'
                    );
                },
                ajax: {
                    url: ajax_url,
                    dataType: 'json',
                    data: function (params) {
                        var query = {
                            username: params.term,
                            page: params.page || 1,
                        };
                        if (window.App.user) {
                            query.except = window.App.user.uuid;
                        }
                        return query;
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data.data, function (user) {
                                return {
                                    id: user.username,
                                    text: user.username,
                                    username: user.username,
                                    avatar: user.avatar,
                                };
                            }),
                            pagination: {
                                more:
                                    data.meta.pagination.current_page <
                                    data.meta.pagination.total_pages,
                            },
                        };
                    },
                },
            });
        });

        function tickCountdown(el) {
            var $el = $(el);

            var target_time = $el.data('countdown-to');
            var current_time = Date.now();
            var days, hours, mins;

            if (isNaN(target_time) || target_time < current_time) {
                days = hours = mins = 0;
            } else {
                var delta = Math.abs(target_time - current_time) / 1000;

                days = Math.floor(delta / 86400);
                delta -= days * 86400;

                hours = Math.floor(delta / 3600) % 24;
                delta -= hours * 3600;

                mins = Math.floor(delta / 60) % 60;
                delta -= mins * 60;
            }

            $el.find('.event-countdown-days').html(days);
            $el.find('.event-countdown-hours').html(hours);
            $el.find('.event-countdown-mins').html(mins);

            // refresh the countdown every 5 seconds
            setTimeout(function () {
                tickCountdown(el);
            }, 5000);
        }

        $('.event-countdown').each(function (index, el) {
            tickCountdown(el);
        });
    });
})();


function setFullHeight() {
    let navBar = document.querySelector('.navbar.sticky-top');
    let navBarMargin = parseInt(getComputedStyle(navBar).marginBottom, 10);
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${navBar.clientHeight + navBarMargin}px`);
}

document.addEventListener('DOMContentLoaded', setFullHeight);
window.addEventListener('resize', setFullHeight);


document.addEventListener('DOMContentLoaded', function () {
    const currentHost = window.location.host;

    document.querySelectorAll('a[href^="http"]').forEach(link => {
        const linkHost = new URL(link.href).host;

        if (linkHost !== currentHost) {
            let linkHref = link.getAttribute('href');
            link.addEventListener('click', function (e) {
                const confirmLeave = confirm(`You are about to leave nakedmates.com and go to "${linkHref}". Are you sure you want to continue?  Naked Mates does not accept any responsibility for content you may encounter externally and advises you to be aware of scammers and unexpected links.`);
                if (!confirmLeave) {
                    e.preventDefault();
                }
            });
        }
    });

    let agePopup = document.querySelector('.age-overlay');


    if (sessionStorage.getItem('agePopupClosed')!='true') {
        document.body.classList.add('age-unverified')
    }


    let buttons = agePopup.querySelectorAll('.btn');
    [...buttons].forEach((el) => el.addEventListener('click', function(event) {
        event.preventDefault();

        sessionStorage.setItem('agePopupClosed', 'true'); // Set flag

        if (event.currentTarget.hasAttribute('data-close')) {
            document.body.classList.remove('age-unverified')
            return;
        }

        window.location.href = event.currentTarget.getAttribute('href');

    }));
});
